import { palette } from './Palette';

/**
 * Roles for colors. Define different colors with their type or role. Change the color codes from the palette file.
 */
export const colors = {
  /**
   * The palette is available to use, but prefer using the name.
   */
  palette,
  /**
   * more colors will be added
   */

  primaryBackground: '', // will be added
  primaryText: '', // will be added
  primaryBorder: '', // will be added
  contentBackground: '', // will be added
  secondaryBackground: '', // will be added
  success: '', // will be added
  successAction: '', // will be added
  link: '', // will be added
  primary: '', // will be added
  tertiaryText: '', // will be added
};

export default colors;
